import React, { useEffect, useState } from 'react';
import '../styles/SideBar.css';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import { ReactComponent as Collapsedlogo } from '../assets/svg/US-collapsed.svg';
import { ReactComponent as FullLogo } from '../assets/svg/US-full.svg';
import { ReactComponent as Content } from '../assets/svg/content.svg';
import { ReactComponent as Logout } from '../assets/svg/logout.svg';
import { ReactComponent as NavPin } from '../assets/svg/nav-pin.svg';
import { ReactComponent as ToastBell } from '../assets/svg/toastBell.svg';
import { useUser } from '../auth/UseUser';
import LogoutModal from './modals/LogoutModal';
import SendNotificationModal from './modals/SendNotificationModal';
import CustomLogoIcon from '../assets/svg/CustomLogoIcon';

function SideBar() {
	const [homestatus, setHomestatus] = useState('/dashboard');
	const currentPath = window.location.pathname;
	const { user, setUser } = useUser();
	const [collapsed, setCollapsed] = useState(false);
	const [isPinned, setIsPinned] = useState(true);
	const [logoutModalOpen, setLogoutModalOpen] = useState(false);
	const [notificationModalOpen, setNotificationModalOpen] = useState(false);

	useEffect(() => {
		const element = document.getElementById('home-container');
		if (!!element) element.style.marginLeft = isPinned ? '280px' : '80px';
	}, [isPinned]);

	const renderIcon = (name: string, color: string) => {
		switch (name) {
			case 'courses':
				return <Content fill={color} />;
			case 'practices':
				return <Content fill={color} />;
			case 'solutions':
				return <Content fill={color} />;
			case 'logout':
				return <Logout fill={color} />;
			default:
				return <Content fill={color} />;
		}
	};

	const sidebarData = [
		{
			name: 'courses',
			title: 'Courses',
			path: ['/courses'],
			className: 'nav-text',
		},
		{
			name: 'course-categories',
			title: 'Course categories',
			path: ['/course-categories'],
			className: 'nav-text',
		},
		{
			name: 'solutions',
			title: 'Solutions',
			path: ['/solutions'],
			className: 'nav-text',
		},
		{
			name: 'solution-categories',
			title: 'Solution categories',
			path: ['/solution-categories'],
			className: 'nav-text',
		},
		{
			name: 'quick-tips',
			title: 'Quick tips',
			path: ['/quick-tips'],
			className: 'nav-text',
		},
		// {
		// 	name: 'solutions',
		// 	title: 'Solutions',
		// 	path: ['/parent-solutions'],
		// 	className: 'nav-text',
		// },
		// {
		// 	name: 'solution-categories',
		// 	title: 'Solution categories',
		// 	path: ['/parent-solution-categories'],
		// 	className: 'nav-text',
		// },
		// {
		// 	name: 'quick-tips',
		// 	title: 'Quick tips',
		// 	path: ['/parent-quick-tips'],
		// 	className: 'nav-text',
		// },

		{
			name: 'struggle-recommendations',
			title: 'Struggle Recommendations',
			path: ['/struggle-recommendations'],
			className: 'nav-text',
		},
		{
			name: 'user-management',
			title: 'User management',
			path: ['/user-management'],
			className: 'nav-text',
		},
		{
			name: 'onboarding-analytics',
			title: 'Onboarding analytics',
			path: ['/onboarding-analytics'],
			className: 'nav-text',
		},
		{
			name: 'ai-prompts',
			title: 'AI Prompts',
			path: ['/ai-prompts'],
			className: 'nav-text',
		},
		{
			name: 'privileged-access',
			title: 'Privileged Access',
			path: ['/privileged-access'],
			className: 'nav-text',
		},
	];

	const closeModal = () => {
		setLogoutModalOpen(false);
	};

	const openLogoutModal = () => {
		setLogoutModalOpen(true);
	};

	const logout = () => {
		localStorage.clear();
		setUser({});
		setLogoutModalOpen(false);
	};

	return (
		<div id='sideBar' className={`side-bar bg-primaryViolet ${collapsed ? 'side-bar-collapsed' : 'side-bar-open'}`} style={collapsed ? { width: 80 } : {}}>
			<div
				className='flex h-[100vh] w-full flex-col items-center'
				onMouseLeave={() => {
					setCollapsed(isPinned ? false : true);
				}}
				onMouseEnter={() => setCollapsed(false)}
			>
				<div className='nav-pin bg-primaryViolet' onClick={() => setIsPinned(!isPinned)}>
					<NavPin fill={isPinned ? '#FDDF6D' : '#F8F8FB'} style={{ display: 'block' }} />
				</div>
				<div className='relative mt-6 flex min-h-[100px] cursor-pointer flex-row items-center justify-center' onClick={() => {}}>
					<div className={`upstrive-logo-collapsed`}>
						{/* <CustomLogoIcon width={collapsed ? 80 : 200} height={200} style={{ transition: 'all 300ms ease-in-out' }} /> */}
						<img src={require('../assets/images/logo-reverse-color.png')} alt='Logo' width={collapsed ? 80 : 200} height={200} style={{ transition: 'all 300ms ease-in-out' }} />
					</div>
				</div>

				<div className='mt-1 flex w-full flex-col overflow-y-auto overflow-x-hidden pl-[30px] xl3:mt-6'>
					<div className=' flex h-[100vh] flex-col justify-between text-lg font-bold text-[#F8F8FB]'>
						<div className='link-list'>
							{sidebarData.map((item: any, index: number) => {
								return (
									<div className={`my-0 xl3:my-2 ${item.className}`} key={index}>
										<div className={`mr-[30px] ${item.path[0] === '/solutions' ? 'border-t border-t-white' : ''}`}></div>
										{item.path[0] === '/parent-solutions' && (
											<div className='border-t border-b border-t-journalGreen border-b-journalGreen py-3 mt-3 -ml-[30px] max-h-[52px] overflow-hidden'>
												<p className='text-[22px] leading-7 font-bold text-journalGreen text-center'>{collapsed ? 'Parent' : 'Parent section'}</p>
											</div>
										)}
										{item.path[0] === '/courses' && (
											<div className='border-t border-b border-t-journalGreen border-b-journalGreen py-3 mt-3 -ml-[30px] max-h-[52px] overflow-hidden'>
												<p className='text-[22px] leading-7 font-bold text-journalGreen text-center'>{collapsed ? 'Cont..' : 'Content'}</p>
											</div>
										)}
										{item.path[0] === '/user-management' && (
											<div className='border-t border-b border-t-journalGreen border-b-journalGreen py-3 mt-3 -ml-[30px] max-h-[52px] overflow-hidden'>
												<p className='text-[22px] leading-7 font-bold text-journalGreen text-center'>{collapsed ? 'Users' : 'User management'}</p>
											</div>
										)}

										<div key={item?.path[0]} data-title={item.title}>
											<Link to={item?.path[0]} onClick={() => setHomestatus(item.path[0])}>
												<div className={`relative flex h-[52px]  w-full flex-row items-center`}>
													<div className='items-center'>{renderIcon(item?.name, currentPath.includes(item.path) ? '#FDDF6D' : '#F8F8FB')}</div>
													{!!item?.icon && <div className='chat-badge-wrapper'>{item?.icon}</div>}
													{!collapsed && <span className={`ellipsis w-full px-3 ${currentPath.includes(item.path) ? ' text-brandYellow' : ''}`}>{item.title}</span>}
												</div>
											</Link>
										</div>
									</div>
								);
							})}
						</div>
						<div className='bottom-container'>
							{/* <div
								className=' nav-text cursor-pointer'
								onClick={() => {
									setHomestatus('/settings');
								}}
							>
								<Link to='/settings'>
									<div className={`relative flex h-[52px]  flex-row items-center`}>
										<div className='items-center'>{renderIcon('settings', homestatus === '/settings' ? '#FDDF6D' : '#F8F8FB')}</div>
										{!collapsed && <span className={`px-3 ${homestatus === '/settings' ? ' text-brandYellow' : ''}`}>Settings</span>}
									</div>
								</Link>
							</div> */}
							<div className=' nav-text cursor-pointer'>
								<div className={`relative flex h-[52px]  flex-row items-center`} onClick={() => setNotificationModalOpen(true)}>
									<div className='items-center'>
										<ToastBell />
									</div>
									{!collapsed && <span className='cursor-pointer px-3'>Send Notification</span>}
								</div>
							</div>
							<div className=' nav-text cursor-pointer'>
								<div className={`relative flex h-[52px]  flex-row items-center`} onClick={() => openLogoutModal()}>
									<div className='items-center'>{renderIcon('logout', '#F8F8FB')}</div>
									{!collapsed && <span className='cursor-pointer px-3'>Logout</span>}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<LogoutModal modalIsOpen={logoutModalOpen} closeModal={closeModal} logout={logout} />
			<SendNotificationModal modalIsOpen={notificationModalOpen} closeModal={() => setNotificationModalOpen(false)} />
		</div>
	);
}

export default SideBar;
